var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCountTotalResponsesQuery } from '../../../store/services/pollsApi';
const TotalResponses = ({ pollId }) => {
    _react_refresh_temp_2();
    const { data, isLoading } = useGetCountTotalResponsesQuery(pollId);
    const [total, setTotal] = useState(0);
    const { t } = useTranslation();
    useEffect(() => {
        var _a;
        if (!isLoading && data) {
            if (data.status) {
                setTotal((_a = Number(data.totalResponses)) !== null && _a !== void 0 ? _a : 0);
            }
        }
    }, [data, isLoading]);
    return (_jsxs("div", { className: "total-vote rounded-bl-lg bg-secondaryColor absolute top-0 right-0 text-white text-[10px] py-1 px-3 uppercase", children: [_jsxs("strong", { children: [t('polls.total'), ": "] }), " ", total] }));
};
_react_refresh_temp_1 = TotalResponses;
$RefreshReg$(_react_refresh_temp_1, "TotalResponses");
_react_refresh_temp_2(TotalResponses, "lRdvn8wE8OVG37OfRsRfnDiZqYk=", false, () => [useGetCountTotalResponsesQuery, useTranslation]);
export default TotalResponses;
